import {Field, reduxForm} from 'redux-form'
import styles from './FeedbackForm.css'

class CustomerFeedbackForm extends React.Component {
  render () {
    let {handleSubmit} = this.props
    return (
      <form onSubmit={handleSubmit} className={styles['form-cust-feedback']}>
        <div className={styles['feedback-options']}>
          <div className={styles['radio-option']}>
            <Field
              name='feedbackType'
              component='input'
              type='radio'
              value='wait_time' />
            <span className={styles['label-radio']}>Wait Time</span>
          </div>
          <div className={styles['radio-option']}>
            <Field
              name='feedbackType'
              component='input'
              type='radio'
              value='quality' />
            <span className={styles['label-radio']}>Quality</span>
          </div>
          <div className={styles['radio-option']}>
            <Field
              name='feedbackType'
              component='input'
              type='radio'
              value='customer_service' />
            <span className={styles['label-radio']}>Customer Service</span>
          </div>
          <div className={styles['radio-option']}>
            <Field
              name='feedbackType'
              component='input'
              type='radio'
              value='other' />
            <span className={styles['label-radio']}>Other</span>
          </div>
        </div>
        <div className={styles['comment-field']}>
          <Field
            name='comment'
            component='textarea'
            className='form-control'
            placeholder='Leave a comment'
          />
        </div>
        <div>
          <button
            type='submit'
            className={`btn btn-primary ${styles['submit-btn']}`}>
            SUBMIT
          </button>
        </div>
      </form>
    )
  }
}

const mapForm = {
  form: 'customerFeedbackForm'
}

export default reduxForm(mapForm)(CustomerFeedbackForm)



// WEBPACK FOOTER //
// ./app/pages/FeedbackForm/CustomerFeedbackForm.js